export type Scope =
  | 'sys_admin'
  | 'settings_all'
  | 'settings_user'
  | 'settings_roles'
  | 'settings_offices'
  | 'settings_cost_codes'
  | 'settings_customers'
  | 'settings_contacts'
  | 'settings_rates'
  | 'settings_pay_codes'
  | 'settings_classifications'
  | 'settings_workflows'
  | 'settings_milestones'
  | 'settings_changes'
  | 'settings_documents'
  | 'settings_login_history'
  | 'modules_all'
  | 'ctc'
  | 'jobs'
  | 'changes'
  | 'rfis'
  | 'inspections'
  | 'activity_feed'
  | 'operations'
  | 'time'
  | 'reports'
  | 'manhours'
  | 'analytics'
  | 'safety'
  | 'service_work'
  | 'service_work_all'
  | 'ctc_create_job'
  | 'ctc_activity_feed'
  | 'ctc_labor_rates'
  | 'ctc_adjustments'
  | 'job_summary_all'
  | 'job_summary_update_details'
  | 'job_summary_view_progress'
  | 'job_summary_update_progress'
  | 'job_summary_estimated_vs_actual'
  | 'job_summary_view_manhours'
  | 'jobs_all'
  | 'jobs_summary'
  | 'jobs_activity'
  | 'jobs_emails'
  | 'jobs_progress'
  | 'jobs_progress_grouping'
  | 'jobs_milestones'
  | 'jobs_meeting_minutes'
  | 'jobs_tracker'
  | 'jobs_contacts'
  | 'jobs_dailys'
  | 'jobs_work_tickets'
  | 'jobs_changes'
  | 'jobs_timesheets'
  | 'jobs_timesheets_admin'
  | 'jobs_rfis'
  | 'jobs_documents'
  | 'jobs_transmittals'
  | 'jobs_drawings'
  | 'jobs_submittals'
  | 'jobs_settings_all'
  | 'jobs_settings_archive_jobs'
  | 'jobs_settings_team'
  | 'jobs_settings_wbs'
  | 'jobs_settings_workflows'
  | 'jobs_settings_rates'
  | 'jobs_settings_questions'
  | 'jobs_settings_hyperlinks'
  | 'jobs_settings_templates'
  | 'jobs_settings_design_models'
  | 'reports_timesheet_payroll'
  | 'reports_timesheet_audit'
  | 'chatbot';

export interface IScope {
  label: string;
  value: Scope;
  description?: string;
}
export interface IScopeSection {
  title: string;
  description?: string;
  all_scope?: Scope;
  scopes: IScope[];
}

export const ProgressViewerScopes: Scope[] = ['jobs_all', 'jobs_progress'];

export const FiretrolAdminScopes: IScopeSection[] = [
  {
    title: 'System Admin',
    scopes: [
      {
        label: 'System Wide Admin',
        value: 'sys_admin',
      },
    ],
  },
];
export const FiretrolJobAdminScopes: IScopeSection[] = [
  {
    title: 'Module Admin',
    scopes: [
      {
        label: 'Timesheets Admin',
        value: 'jobs_timesheets_admin',
        description:
          'Allows the user to administrate timesheets for a job, including updating approved timesheets.',
      },
    ],
  },
];
export const FiretrolScopes: IScopeSection[] = [
  {
    title: 'Admin Settings',
    all_scope: 'settings_all',
    scopes: [
      {
        label: 'All Admin Settings',
        value: 'settings_all',
      },
      {
        label: 'Users',
        value: 'settings_user',
      },
      {
        label: 'Roles',
        value: 'settings_roles',
      },
      {
        label: 'Offices',
        value: 'settings_offices',
      },
      {
        label: 'Cost Codes',
        value: 'settings_cost_codes',
      },
      {
        label: 'Customers',
        value: 'settings_customers',
      },
      {
        label: 'Contacts',
        value: 'settings_contacts',
      },
      {
        label: 'Rates',
        value: 'settings_rates',
      },
      {
        label: 'Pay Codes',
        value: 'settings_pay_codes',
      },
      {
        label: 'Classifications',
        value: 'settings_classifications',
      },
      {
        label: 'Workflows',
        value: 'settings_workflows',
      },
      {
        label: 'Milestones',
        value: 'settings_milestones',
      },
      {
        label: 'Changes',
        value: 'settings_changes',
      },
      {
        label: 'User Login History',
        value: 'settings_login_history',
      },
      {
        label: 'Documents',
        value: 'settings_documents',
      },
    ],
  },
  {
    title: 'Main Modules',
    all_scope: 'modules_all',
    scopes: [
      {
        label: 'All Modules',
        value: 'modules_all',
      },
      {
        label: 'CTC',
        value: 'ctc',
      },
      {
        label: 'Jobs',
        value: 'jobs',
      },
      {
        label: 'Changes',
        value: 'changes',
      },
      {
        label: 'RFIs',
        value: 'rfis',
      },
      {
        label: 'Inspections',
        value: 'inspections',
      },
      {
        label: 'Activity Feed',
        value: 'activity_feed',
      },
      {
        label: 'Operations',
        value: 'operations',
      },
      {
        label: 'Time',
        value: 'time',
      },
      {
        label: 'Reports',
        value: 'reports',
      },
      {
        label: 'Manhours',
        value: 'manhours',
      },
      {
        label: 'Data Analytics',
        value: 'analytics',
      },
      {
        label: 'Safety',
        value: 'safety',
        description: 'Access to safety forms and resources.',
      },
      {
        label: 'Service Work',
        value: 'service_work',
        description:
          'Access to personal service jobs for tracking service work.',
      },
      {
        label: 'Service Work (All)',
        value: 'service_work_all',
        description:
          'Access to view and manage all service jobs across the organization.',
      },
    ],
  },
  {
    title: 'AI',
    scopes: [
      {
        label: 'F.I.R.E. (AI Assistant)',
        value: 'chatbot',
        description: 'Access to the AI assistant chat.',
      },
    ],
  },
  {
    title: 'Reports',
    scopes: [
      {
        label: 'Timesheet Payroll Report',
        value: 'reports_timesheet_payroll',
        description:
          'Access to the Timesheet Payroll Report for aggregated payroll data.',
      },
      {
        label: 'Timesheet Audit Report',
        value: 'reports_timesheet_audit',
        description:
          'Access to the Timesheet Audit Report for detailed individual timesheet data.',
      },
    ],
  },
  {
    title: 'CTC',
    scopes: [
      {
        label: 'Create / Link Jobs',
        value: 'ctc_create_job',
      },
      {
        label: 'View CTC Activity Feed',
        value: 'ctc_activity_feed',
      },
      {
        label: 'View CTC Labor Rates',
        value: 'ctc_labor_rates',
      },
      {
        label: 'View CTC Adjustments',
        value: 'ctc_adjustments',
      },
    ],
  },
  {
    title: 'Job Summary',
    all_scope: 'job_summary_all',
    scopes: [
      {
        label: 'All Job Summary',
        value: 'job_summary_all',
      },
      {
        label: 'Update Job Details',
        value: 'job_summary_update_details',
      },
      {
        label: 'View Physical Progress',
        value: 'job_summary_view_progress',
      },
      {
        label: 'Update Physical Progress',
        value: 'job_summary_update_progress',
      },
      {
        label: 'Estimated vs Actual',
        value: 'job_summary_estimated_vs_actual',
      },
      {
        label: 'View Manhours',
        value: 'job_summary_view_manhours',
      },
    ],
  },
  {
    title: 'Job Modules',
    all_scope: 'jobs_all',
    scopes: [
      {
        label: 'All Job Modules',
        value: 'jobs_all',
      },
      {
        label: 'Summary',
        value: 'jobs_summary',
      },
      {
        label: 'Activity Feed',
        value: 'jobs_activity',
      },
      {
        label: 'Emails',
        value: 'jobs_emails',
      },
      {
        label: 'Progress',
        value: 'jobs_progress',
      },
      {
        label: 'Progress Grouping',
        value: 'jobs_progress_grouping',
      },
      {
        label: 'Milestones',
        value: 'jobs_milestones',
      },
      {
        label: 'Meeting Minutes',
        value: 'jobs_meeting_minutes',
      },
      {
        label: 'Tracker',
        value: 'jobs_tracker',
      },
      {
        label: 'Contacts',
        value: 'jobs_contacts',
      },
      {
        label: 'Dailys',
        value: 'jobs_dailys',
      },
      {
        label: 'Work Tickets',
        value: 'jobs_work_tickets',
      },
      {
        label: 'Changes',
        value: 'jobs_changes',
      },
      {
        label: 'Timesheets',
        value: 'jobs_timesheets',
      },
      {
        label: 'RFIs',
        value: 'jobs_rfis',
      },
      {
        label: 'Documents',
        value: 'jobs_documents',
      },
      {
        label: 'Transmittals',
        value: 'jobs_transmittals',
      },
      {
        label: 'Drawings',
        value: 'jobs_drawings',
      },
      {
        label: 'Submittals',
        value: 'jobs_submittals',
      },
    ],
  },
  {
    title: 'Job Settings',
    all_scope: 'jobs_settings_all',
    scopes: [
      {
        label: 'All Job Settings',
        value: 'jobs_settings_all',
      },
      {
        label: 'Archive Jobs',
        value: 'jobs_settings_archive_jobs',
      },
      {
        label: 'Project Team',
        value: 'jobs_settings_team',
      },
      {
        label: 'WBS',
        value: 'jobs_settings_wbs',
      },
      {
        label: 'Workflows',
        value: 'jobs_settings_workflows',
      },
      {
        label: 'Rate Sheet',
        value: 'jobs_settings_rates',
      },
      {
        label: 'Questions',
        value: 'jobs_settings_questions',
      },
      {
        label: 'Hyperlinks',
        value: 'jobs_settings_hyperlinks',
      },
      {
        label: 'Templates',
        value: 'jobs_settings_templates',
      },
      {
        label: 'Design Models',
        value: 'jobs_settings_design_models',
      },
    ],
  },
];
